import { oz } from '@weft/utils';

import { InvoiceCreatedFromApiEventPayloadSchema } from './invoice-create-event-payload-types/invoice-created-from-api-event-payload';
import { InvoiceCreatedFromPricingEventPayloadSchema } from './invoice-create-event-payload-types/invoice-created-from-pricing-event-payload';

export const InvoiceCreatedEventPayloadSchema = oz.discriminatedUnion('type', [
  InvoiceCreatedFromApiEventPayloadSchema,
  InvoiceCreatedFromPricingEventPayloadSchema,
]);

export type InvoiceCreatedEventPayload = oz.infer<typeof InvoiceCreatedEventPayloadSchema>;